import { UserData, getUserFlags } from "common/Database";
import * as actions from "../../actions/actions";
import * as userActions from "../../actions/user-actions";
import { getCurrentTermsOfService } from "common/terms-of-service";
import { getBuilderUserDatabase } from "../../lib/web-database";
import { trackEvent } from "../../analytics";
import { MappedThunk } from "../../actions/action-thunk";
import { dontAwait } from "common/Support";
import { getModals } from "designer/modals-v2/modal-provider-v2/externalAPI";
import { TermsOfServiceModal } from "designer/modals/views/terms-of-service-modal/terms-of-service-modal";

export async function handleTermsOfServiceUpdate(
    userData: UserData,
    setLastAcceptedTermsOfService: MappedThunk<typeof userActions.setLastAcceptedTermsOfService>,
    signOut: MappedThunk<typeof actions.signOut>
): Promise<void> {
    const currentTermsOfService = await getCurrentTermsOfService(getBuilderUserDatabase(userData.id));
    if (currentTermsOfService === undefined) return;

    const lastAcceptedTermsOfService: number = getUserFlags(userData).lastAcceptedTermsOfService;

    if (lastAcceptedTermsOfService === 0 || lastAcceptedTermsOfService === currentTermsOfService.currentVersion) {
        return;
    }

    const { termsLink, privacyLink, currentVersion } = currentTermsOfService;

    const accepted = await getModals().showModal(resolve => {
        return <TermsOfServiceModal resolve={resolve} termsLink={termsLink} privacyLink={privacyLink} />;
    });
    if (!accepted) {
        trackEvent("tos_update_dialog", { status: "reject" });
        await signOut();
    } else {
        trackEvent("tos_update_dialog", { status: "accept" });
        dontAwait(setLastAcceptedTermsOfService(currentVersion));
    }
}

export async function handleFirstTermsOfService(
    userData: UserData,
    setLastAcceptedTermsOfService: MappedThunk<typeof userActions.setLastAcceptedTermsOfService>,
    signOut: MappedThunk<typeof actions.signOut>,
    accepted: boolean
): Promise<void> {
    const currentTermsOfService = await getCurrentTermsOfService(getBuilderUserDatabase(userData.id));
    if (currentTermsOfService === undefined) return;

    const lastAcceptedTermsOfService: number = getUserFlags(userData).lastAcceptedTermsOfService;

    if (lastAcceptedTermsOfService !== 0 && lastAcceptedTermsOfService === currentTermsOfService.currentVersion) {
        return;
    }

    const { currentVersion } = currentTermsOfService;

    if (!accepted) {
        trackEvent("tos_update_dialog", { status: "reject" });
        await signOut();
    } else {
        trackEvent("tos_update_dialog", { status: "accept" });
        await setLastAcceptedTermsOfService(currentVersion);
    }
}
